import { useEffect, useState } from "react";
import { useHistory } from "react-router";

import {
  initialPagination,
  initialSearchParams,
  PaginationType,
  SearchParams,
  useDebounce,
} from "helpers";
import { getReviews, Review } from "services/reviews";

export const useReviewsPage = () => {
  const history = useHistory();

  const [data, setData] = useState<Review[]>([]);
  const [pagination, setPagination] =
    useState<PaginationType>(initialPagination);
  const [search, setSearch] = useState<SearchParams>(initialSearchParams);
  const debouncedValue = useDebounce(search.search);

  useEffect(() => {
    (async () => {
      const resp = await getReviews(pagination, search);
      setData(resp.data);
      setPagination((old) => ({
        ...old,
        totalRows: resp.meta.totalRows,
      }));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  const onRowClick = (row: Review) => {
    history.push(`reviews/${row.id}`);
  };

  const onNextClick = async () => {
    const newPagination = {
      ...pagination,
      currentPage: pagination.currentPage + 1,
    };
    const resp = await getReviews(newPagination, search);
    setData(resp.data);
    setPagination(newPagination);
  };

  const onPreviousClick = async () => {
    const newPagination = {
      ...pagination,
      currentPage: pagination.currentPage - 1,
    };
    const resp = await getReviews(newPagination, search);
    setData(resp.data);
    setPagination(newPagination);
  };

  const onTableHeaderClick = async (accessor: string) => {
    const newSearch: SearchParams = {
      ...search,
      sortBy: accessor,
      descending: search.sortBy === accessor ? !search.descending : true,
    };
    const resp = await getReviews(pagination, newSearch);
    setData(resp.data);
    setSearch(newSearch);
  };

  const onSearchChanged = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const pimpek = e.target.value;

    const newSearch: SearchParams = {
      ...search,
      search: pimpek.trim(),
    };

    setSearch(newSearch);
  };

  return {
    data,
    pagination,
    search,
    onRowClick,
    onNextClick,
    onPreviousClick,
    onSearchChanged,
    onTableHeaderClick,
  };
};
